import { registerMessages } from "../../../i18n/runtime";
import { cashEn } from "./messages.en";
import { cashEs } from "./messages.es";
registerMessages("en", cashEn);
registerMessages("es", cashEs);
